// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6b625c95a75c52185b0a","691":"658e2d7d2debe4c464c2"}[chunkId] + ".js";
};